import { useEffect, useRef } from "react";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtDate, isPackageActive } from "@/lib/format";

const W = 1012;
const H = 638;

export const studentNumber = (u) => `ADH-${u.id.replace(/-/g, "").slice(0, 8).toUpperCase()}`;

function drawCard(ctx, user, pkgName) {
  const active = isPackageActive(user);
  ctx.fillStyle = "#0F172A";
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = "rgba(148,163,184,0.10)";
  for (let x = 0; x <= W; x += 40) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, H); ctx.stroke(); }
  for (let y = 0; y <= H; y += 40) { ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(W, y); ctx.stroke(); }
  ctx.fillStyle = "#F59E0B";
  ctx.fillRect(0, 0, 18, H);
  ctx.fillRect(64, 56, 64, 64);
  ctx.fillStyle = "#0F172A";
  ctx.font = "800 40px Outfit, sans-serif";
  ctx.fillText("A", 82, 103);
  ctx.fillStyle = "#FFFFFF";
  ctx.font = "800 34px Outfit, sans-serif";
  ctx.fillText("ADHISATYA", 148, 88);
  ctx.fillStyle = "#94A3B8";
  ctx.font = "600 16px 'Plus Jakarta Sans', sans-serif";
  ctx.fillText("LEMBAGA BIMBINGAN", 148, 114);
  ctx.fillStyle = "#F59E0B";
  ctx.font = "700 18px 'Plus Jakarta Sans', sans-serif";
  ctx.textAlign = "right";
  ctx.fillText("KARTU SISWA", W - 64, 92);
  ctx.textAlign = "left";
  ctx.fillStyle = "#FFFFFF";
  let size = 54;
  ctx.font = `800 ${size}px Outfit, sans-serif`;
  while (size > 28 && ctx.measureText(user.name).width > W - 128) {
    size -= 2;
    ctx.font = `800 ${size}px Outfit, sans-serif`;
  }
  ctx.fillText(user.name, 64, 250, W - 128);
  ctx.fillStyle = "#CBD5E1";
  ctx.font = "700 24px 'JetBrains Mono', monospace";
  ctx.fillText(studentNumber(user), 64, 296);
  const rows = [["PAKET AKTIF", pkgName || "-"], ["BERLAKU S.D.", user.package_expires_at ? fmtDate(user.package_expires_at) : "-"]];
  rows.forEach(([label, value], i) => {
    const x = 64 + i * 440;
    ctx.fillStyle = "#94A3B8";
    ctx.font = "600 16px 'Plus Jakarta Sans', sans-serif";
    ctx.fillText(label, x, 430);
    ctx.fillStyle = "#FFFFFF";
    ctx.font = "700 30px Outfit, sans-serif";
    ctx.fillText(value.slice(0, 22), x, 472);
  });
  ctx.fillStyle = active ? "#10B981" : "#EF4444";
  ctx.fillRect(64, 530, 150, 44);
  ctx.fillStyle = "#FFFFFF";
  ctx.font = "800 20px 'Plus Jakarta Sans', sans-serif";
  ctx.fillText(active ? "AKTIF" : "TIDAK AKTIF", 82, 559);
  ctx.fillStyle = "#CBD5E1";
  ctx.font = "500 18px 'Plus Jakarta Sans', sans-serif";
  ctx.textAlign = "right";
  ctx.fillText(user.email, W - 64, 559);
  ctx.textAlign = "left";
}

export default function StudentCard({ user, pkgName }) {
  const ref = useRef(null);
  useEffect(() => {
    let alive = true;
    document.fonts.ready.then(() => {
      if (alive && ref.current) drawCard(ref.current.getContext("2d"), user, pkgName);
    });
    return () => { alive = false; };
  }, [user, pkgName]);
  const download = () => {
    const a = document.createElement("a");
    a.href = ref.current.toDataURL("image/png");
    a.download = `kartu-siswa-${studentNumber(user)}.png`;
    a.click();
  };
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-6" data-testid="student-card-section">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <p className="font-display font-semibold">Kartu siswa digital</p>
        <Button onClick={download} variant="outline" disabled={!isPackageActive(user)} data-testid="download-student-card-button"><Download className="h-4 w-4 mr-2" />Unduh Kartu (PNG)</Button>
      </div>
      {!isPackageActive(user) && <p className="text-xs text-slate-500 mb-3">Kartu dapat diunduh setelah paket aktif.</p>}
      <canvas ref={ref} width={W} height={H} className="w-full max-w-xl rounded-lg shadow-lg" data-testid="student-card-canvas" />
    </div>
  );
}
